
// 格式下拉框数据
export function enumType(data) {
  if(data && data.length > 0) {
    let enumArray = []
    data.forEach(item => {
      let obj = {
        value: item.dictValue,
        label: item.dictLabel
      }
      enumArray.push(obj)
    })
    return enumArray
  }
}
